<template>
    <div v-if="inError" class="error-content row mx-3 mx-md-0 align-items-center" role="alert" aria-live="polite">
        <div class="col-md-2 col-12 text-center">
            <fa-icon :icon="['fas','exclamation-triangle']" class="error-shield" />
        </div>
        <div class="col-md-10 col-12">
            <strong>{{type}}</strong>
            <p class="my-2">
                <span v-html="preContactUsMessage"></span>
                <span v-html="contactUsMessage"></span>
            </p>
            <p><slot></slot></p>
            <p v-for="(error, index) in list" v-html="getErrorMessage(error, index)"></p>
        </div>
    </div>    
</template>

<script>
import { nextTick } from 'vue'
import {sendAnalyticsData} from "../../../utility/miscellaneous";
    export default {
        name: "Error",

        data: function() {
            return {
                type: "",
                list: [],
                inError: false,
                preContactUsMessage: "",
                lowerFirstContactUsMsg: false
            }
        },

        methods: {
            sendAnalyticsData,
            display: function(code, message, type, preContactUsMessage, lowerFirstContactUsMsg) {
                this.list.push({
                    code: code,
                    message: message
                });
                this.type = type;
                this.preContactUsMessage = (preContactUsMessage || this.getGenericErrorMessage()) + " ";
                this.lowerFirstContactUsMsg = lowerFirstContactUsMsg || false;
                this.inError = true;
                this.sendAnalyticsData({
                    errorCode: code
                });
            },

            displayList: function(list, type) {
                this.type = type;
                this.list = list || [];
                this.inError = true;
            },

            clear: function() {
                this.inError = false;
                this.type = "";
                this.list = [];
            },

            getErrorMessage: function(error, index) {
                var message = "";

                if(error.code === false) return message;

                if (index > 0) {
                    message += "<br>"
                }
				if (!(error.code == "8003" || error.code == "1730" || error.code == "9999" )){
					message += error.code ? "Error Code: " : "";
					message += error.code || "We've experienced a problem...";
				}
                return message;
            }
        },

        computed: {
            contactUsMessage: function() {
                var message = this.getContactUsMessage();
                if (this.lowerFirstContactUsMsg && message && message.length > 0) {
                    message = message.charAt(0).toLowerCase() + message.slice(1);
                }
                return message;
            }
        },

        watch: {
            inError: function(val) {
                if (val) {
                    nextTick(function() {
                        var inView = this.$el.offsetTop >= window.pageYOffset;
                        if (!inView) {
                            this.$el.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
                        }
                    }.bind(this));
                }
            }
        },

        inject: [
            'getContactUsMessage',
            'getGenericErrorMessage'
        ]
    }
</script>

<style scoped>
    :root {
        width: 100%;
    }

    .error-content {
        width: 100%;
        border: .25rem solid var(--input-error-border-color);
        padding: 1rem;
    }

    .error-shield {
        font-size: 2.5rem;
        color: var(--error-message-color);
    }

    p {
        font-size: 1rem;
    }
</style>